<template>
  <div id="filterDropdown" class="list-dropdown">
    <button
      class="btn-dark action-button u-no-margin"
      v-on:click="toggleFilter()"
    >
      <span>Filters</span>
      <span class="icon">
        <i class="fa fa-wrapper fa-caret-down"></i>
      </span>
    </button>
    <ul class="menu" v-bind:class="{ show: showFilter }">
      <div
        v-for="(items, label, index) in options"
        :key="`filter-level-${index}`"
      >
        <li class="menu-item">
          <strong>{{ title(label) }}</strong>
        </li>
        <li
          v-for="(obj, idx) in items"
          :key="`filter-${label}-${idx}`"
          class="menu-item"
          v-bind:class="{ selected: obj.selected }"
        >
          <a href="#" v-on:click="handleFilter(label, obj)">{{ obj.name }}</a>
        </li>
      </div>
    </ul>
  </div>
</template>
<style>
/* Allow for shown and :focus selectors for JS and native CSS transitions */
.list-dropdown .menu.show {
  display: block;
  opacity: 1;
  top: 100%;
  z-index: 100;
  pointer-events: auto; /* Restore pointer events */
  height: auto;
  -webkit-transition: all var(--animation-duration);
  transition: all var(--animation-duration);
}
</style>
<script>
import { titleCase } from "@/functions/titleCase.function.js";

export default {
  name: "filter-dropdown",
  data: function() {
    return {
      showFilter: false
    };
  },
  props: ["options"],
  methods: {
    title(text) {
      return titleCase(text);
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    handleFilter(label, target) {
      var payload = {};
      payload[label] = target.value;
      this.$emit("handle-filter", payload);
    }
  }
};
</script>
